"use client";

import { atom } from "jotai";
import { LedgerTotals } from "../utils/recalculate-ledger-totals-on-status-change.utils";

export type LedgerCalculationState = {
  totals: LedgerTotals | null;
  /** Tracks whether the totals have been modified client-side (e.g., via status change) */
  hasClientModifications: boolean;
};

export const ledgerCalculationAtom = atom<LedgerCalculationState>({
  totals: null,
  hasClientModifications: false,
});
